import {$, w} from './constants';

w.load( () => {
    let device_width = screen.width;
    //Lista dropdown de filtro de marcas en móvil
    let path = window.location.pathname;
    const nodo = $('#text-filtro');
    const todo = $('#todo-link');

    //Pop-up de marcas
    $('.card__directorio').click( (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('#intro-directorio').hide();
        $('#grid-directorio').hide();
        $('.archive').addClass('height-limit');
        //Ocultamos el footer en popup para móvil
        if(screen.width <= 480){
            $('.line-footer-divisor').hide();
            $('.footer').hide();
        }
    });
    function closePopUp() {
        $("#popup-marca").hide();
        $('#intro-directorio').show();
        $('#grid-directorio').show();
        
    }

    /*if(window.location.hash == '#grid-directorio'){
        toScroll("#grid-directorio");
    };
    function toScroll(id_element){
        $('html, body').animate(
            {
              scrollTop: $(id_element).offset().top - 80,
            },
            1200,
            'swing'
        )
    }*/

    

    $('#close-popup').click( () =>{
        closePopUp();
    })
    

    const toggleLink = (flag, clase) =>{

        if(flag){
            todo.removeClass('hide-link');
            todo.addClass('show-link');
            console.log(clase);
            $(clase).hide();
        }else{
            todo.addClass('hide-link');
            todo.removeClass('show-link');
        }
       
    }
    //Categorías de filtrado
    if(path.includes('directorio')){
        console.log('Todos los filtros');
        nodo.html('<span>Todo</span>');
        toggleLink(false, null);
    }else if(path.includes('arte')){
        nodo.html('<span>Arte</span>');
        toggleLink(true, '.arte');
    }else if(path.includes('moda')){
        nodo.html('<span>Moda</span>');
        toggleLink(true, '.moda');
    }else if(path.includes('disenio-utilitario')){
        nodo.html('<span>Diseño Utilitario</span>');
        toggleLink(true, '.disenio-utilitario');
    }else if(path.includes('gastronomia')){
        nodo.html('<span>Gastronomía</span>');
        toggleLink(true, '.gastronomia');
    }else if(path.includes('salud-bienestar')){
        nodo.html('<span>Salud y bienestar</span>');
        toggleLink(true, '.salud-bienestar');
    }else if(path.includes('mascotas')){
        nodo.html('<span>Mascotas</span>');
        toggleLink(true, '.mascotas');
    }else if(path.includes('jardineria')){
        nodo.html('<span>Jardinería</span>');
        toggleLink(true, '.jardineria');
    }else if(path.includes('cosmetica')){
        nodo.html('<span>Cosmética</span>');
        toggleLink(true, '.cosmetica');
    }else if(path.includes('musica')){
        nodo.html('<span>Música</span>');
        toggleLink(true, '.musica');
    }else if(path.includes('otros')){
        nodo.html('<span>Otros</span>');
        toggleLink(true, '.otros');
    }
});




// WEBPACK FOOTER //
// ./es6/directorio.js